import { z } from 'zod'
import { PhotoSubscriberSchema } from './PhotoSubscriberSchema'
import { AvatarSchema } from './AvatarSchema'

export const ShareInfoSchema = z.object({
  admin: z.boolean().default(false).optional(),
  authorization: z.enum(['READ', 'WRITE']).optional(),
  owner: z.string().optional(),
  ownerFullName: z.string().optional(),
  ownerAvatar: AvatarSchema,
  subscribers: z.array(PhotoSubscriberSchema).optional().default([]),
  uri: z.string(),
})
